module.exports = __webpack_public_path__ + "static/media/GUY.a41d9354.svg";